import { render, staticRenderFns } from "./Einzelheiten.vue?vue&type=template&id=228e47d5&"
import script from "./Einzelheiten.vue?vue&type=script&lang=js&"
export * from "./Einzelheiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports